import { PullRefresh, Loading, Toast, Dialog, Uploader, Icon, Popup ,RadioGroup, Radio} from 'vant';//引入组件插件

const components = { PullRefresh, Loading, Toast, Dialog, Uploader, Icon, Popup,RadioGroup, Radio }

const vantComponentsHandler = {
  install(Vue) {
    Object.keys(components).forEach(key => Vue.use(components[key]))
  }
}

export default vantComponentsHandler



//////////////////
// WEBPACK FOOTER
// ./vant.config.js
// module id = null
// module chunks = 